import React, { useState, useEffect, useContext, createContext } from "react";
import { RestApi } from "../services/ApiService";
import { ProductServerAuthContext } from "../providers/ProductServerAuth";

export const useProductApi: <T>() => RestApi<T> | undefined = () => {
  const api = useContext(ProductApiContext);

  return api;
};

export const ProductApiContext = createContext<RestApi<any> | undefined>(undefined);

export const ProductApiContextProvider = (props: { children: any, site: string }) => {
  const auth = useContext(ProductServerAuthContext);
  const [api, setApi] = useState<RestApi<any> | undefined>();
  const token = auth.getSession()?.token;
  const protocol = window.location.protocol;
  useEffect(() => {
    if (!token) return;
    // console.log("ProductApiContextProvider recieved auth", token);

    setApi(new RestApi(`${props.site}/api/`, auth, token));
  }, [token, props.site]);

  return <ProductApiContext.Provider value={api}>{props.children}</ProductApiContext.Provider>;
};

// new RestApi(`https://app.clixscale.com/api/`, auth)
// );
